import { Directive, Input } from '@angular/core';
import {
    AbstractControl,
    NG_VALIDATORS,
    ValidationErrors,
    Validator,
    ValidatorFn
} from '@angular/forms';
import { Decimal } from 'decimal.js';

/**
 * Validate the max number of a `input[type=text]`.
 * Number fields cannot be used because we can’t force English decimal point on them.
 */
@Directive({
    selector: '[pkpMaxDecimalValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: MaxDecimalValidatorDirective,
            multi: true
        }
    ]
})
export class MaxDecimalValidatorDirective implements Validator {
    @Input('pkpMaxDecimalValidator') subject: Decimal.Value;

    validate(control: AbstractControl): ValidationErrors | null {
        try {
            return new Decimal(control.value).lessThanOrEqualTo(this.subject)
                ? null
                : { pkpMaxDecimalValidator: { value: control.value } };
        } catch (e) {
            return null;
        }
    }
}
